import React, { useState } from 'react';
import { ChevronDown, Plus, Minus, HelpCircle } from 'lucide-react';

export default function FAQSection() {

    
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "What is the success rate of AEPS?",
            answer: "Bumppy Payments Aeps portal deliver a transaction success ratio of 99.99%"
        },
        {
            question: "Who can use AePS?",
            answer: "Kirana Shop,Medical Shop,Apparel Shop,Mobile,Recharge Centre Hardware Store ETC can use the Retailer panel services for their customer"
        },
        {
            question: "What are the timings for using AePS ?",
            answer: "Morning 6:00AM to Evening 11 PM You can use the Aeps Service"
        },
        {
            question: "How many times I can withdraw money from AePS?",
            answer: "5 times in a month can withdraw limit upto 10000 only"
        },
        {
            question: "What is the limit of AePS per day?",
            answer: "NPCI has set a maximum transaction amount of Rs. 10,000 on a single AEPS financial transaction."
        },
        {
            question: "What is the meaning of 'No checking Account' in Aeps Transaction",
            answer: "It means Customer adhaar Number is not linked with his Bank Account"
        },
        {
            question: "What is commission for AEPS?",
            answer: "For commission info you can check on profile section Profile >>Select Commission option >>Select AePS"
        },
        {
            question: "AEPS transaction is failed but amount is deducted from the customer bank what id do ?",
            answer: "If transaction status is failed amount is deducted then ask to customer for wait 3-4 working day. Amount will be refunded if still not then raise the chargeback complaint to bank"
        },
        {
            question: "What are the benefits of AePS?",
            answer: "It is a safe and secure method of payment and interoperable across various banks. This system facilitates financial inclusion and encourages people from all parts of the society to avail the financial and banking services."
        },
        // {
        //     question: "How much money can be transfer in a Day with DMT Service?",
        //     answer: "Bumppy Payments Provide the limit of 25000 without Kyc and if KYC has been completed then can be transfer upto 2,00,000"
        // },
        {
            question: "How Much commission can I get on 5000 transaction amount on DMT ?",
            answer: "You can get the 25 Rs Flat on 5000 rs Transaction of Amount and customer will pay the 1% charges"
        },
        {
            question: "DMT Service can be use on Holiday ?",
            answer: "Yes ! Bumppy Payments DMT service is 24*7 Available"
        },
        {
            question: "My DMT transaction is Pending What I do ?",
            answer: "If status is pending then need to wait 24 working hour for an update. After Success amount will be credit to beneficiary and its fail then amount will be refund to wallet"
        },
        {
            question: "Which Biomertic device is Supported in Bumppy Panel?",
            answer: "You can use the Morpho and Mantra Device for the transaction with Bumppy Payments"
        },
        {
            question: "Can I get the commission on Prepaid mobile Recharge ?",
            answer: "Yes !On every Recharge Transaction you can get the commision . For more info visit the Commission section"
        },
        {
            question: "Electricity Bill payment status is successful but still showing not done ?",
            answer: "Sometime Bill can take the time update in provider account . So wait 24 hour it will be update"
        },
        {
            question: "What is the cost of Bumppy mATM device",
            answer: "Cost of mATM device is Rs 1899"
        }
    ];

    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <section className="py-10 bg-white relative overflow-hidden">
            <div className="max-w-4xl mx-auto px-6 relative z-10">

               
                <div className="text-center mb-16 space-y-4">
                   
                    <h2 className="font-spacegrotesk text-slate-900 text-4xl font-bold">
                        Frequently Asked <span className="text-pink-500">Questions</span>
                    </h2>
                    <p className="text-slate-500 font-medium">
                        You will find answers to all your questions here.
                    </p>
                </div>

                
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className={`border rounded-3xl transition-all duration-300 ${openIndex === index
                                ? 'border-blue-200 bg-blue-50/30 shadow-lg shadow-blue-900/5'
                                : 'border-slate-100 bg-white hover:border-slate-200'
                                }`}
                        >
                            <button
                                onClick={() => toggleFAQ(index)}
                                className="w-full flex items-center justify-between p-6 md:p-8 text-left focus:outline-none"
                            >
                                <span className={`text-lg font-bold transition-colors ${openIndex === index ? 'text-blue-700' : 'text-slate-800'
                                    }`}>
                                    {faq.question}
                                </span>
                                <div className={`flex-shrink-0 ml-4 p-2 rounded-full transition-all duration-300 ${openIndex === index ? 'bg-blue-600 text-white rotate-180' : 'bg-slate-100 text-slate-400'
                                    }`}>
                                    <ChevronDown className="w-5 h-5" />
                                </div>
                            </button>

                            <div
                                className={`overflow-hidden transition-all duration-500 ease-in-out ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}
                            >
                                <div className="p-6 md:p-8 pt-0 text-slate-600 leading-relaxed font-medium border-t border-blue-100/50">
                                    {faq.answer}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

               
               
            </div>
        </section>
    );
};

